import type { ApolloClient } from '@apollo/client'

/**
 * Returns `[operationName]` only when a query with that operation name is
 * currently mounted (active), otherwise `[]`.
 *
 * Spread into a mutation's `refetchQueries` so a conditionally-mounted query
 * (e.g. `NextUpIncident`, mounted only while Priority Queue is active) is
 * refreshed when it's on screen — without Apollo logging its `Unknown query
 * named "..."` dev warning when it isn't. Matching by name also covers a query
 * that's mounted with more than one variable-set.
 */
export const includeIfActive = (
  client: ApolloClient<object>,
  operationName: string
): string[] => {
  for (const query of client.getObservableQueries('active').values()) {
    if (query.queryName === operationName) return [operationName]
  }
  return []
}
